import {Injectable} from '@angular/core';
import Stomp from 'stompjs';
import SockJS from 'sockjs-client';
import {Client, Frame} from 'stompjs';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {LocalStorageService} from "./local-storage.service";
import {NotificationsComponent} from "../../layout/common/notifications/notifications.component";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class WebSocketService {
    webSocketEndPoint: string
    topic: string
    stompClient: Client;
    message$ = new BehaviorSubject('');
    constructor(private localStorageService: LocalStorageService) {
    }

    connect() {
        const headers = {Authorization: 'Bearer ' + this.localStorageService.getAccessToken()};
        let ws = new SockJS(this.webSocketEndPoint);
        this.stompClient = undefined;
        console.log(headers)
        this.stompClient = Stomp.over(ws);
        this.stompClient.connect(headers, (frame) => {
            this.stompClient.subscribe(this.topic, (sdkEvent) => {
                this.onMessageReceived(sdkEvent);
            }, headers);
        }, (err) => this.errorCallBack(err));
    };

    subscribe() {
        this.stompClient.subscribe(this.topic, (sdkEvent) => {
            this.onMessageReceived(sdkEvent);
        });
    }

    disconnect() {
        if (this.stompClient !== null) {
            this.stompClient.disconnect();
        }
        console.log("Disconnected");
    }

    // on error, schedule a reconnection attempt
    errorCallBack(error: Frame | string) {
        console.log("errorCallBack -> " + error)
        setTimeout(() => {
            this.connect();
        }, 100 * 1000);
    }


    onMessageReceived(message) {
        console.log(message.body);
        this.message$.next(message.body)
    }

    get messageOsb$(): Observable<string>{
        return  this.message$.asObservable();
    }
}
